module.exports = {
    "id": null,
    "title": "",
    "description": "",
    "largeImageUrl": "",
    "mediumImageUrl": "",
    "type": null,
    "socialCategory": null,
    "linkType": null,
    "linkValue": null,
    "active": false,
};